"use client"
import { useState, useEffect } from "react";
import { humanizeString } from "@/utils/frontend/stringOps";
const RadioButton_1 = ({caption1, caption2, caption3, caption4, value1, value2, value3, value4, callback, callbackObjectKey, defaultChecked}) => {

  const [selectedOption, setSelectedOption] = useState(defaultChecked);
  // console.log('defaultChecked', defaultChecked)
  useEffect(() => {
    setSelectedOption(defaultChecked)
  }, [defaultChecked])
  
  const handleOptionChange = (option) => {
    setSelectedOption(option);
    callback({[callbackObjectKey]: option})
  };
     return (
          <>
   <div className="flex items-center justify-center space-x-1 w-full bg-inherit dark:bg-inherit rounded-lg">
      
        <div
        className={`font-inter w-full text-xs border hover:border-teal-400 font-bold text-center cursor-pointer py-4 rounded-md ease-in-out duration-300 transition-all ${
          selectedOption === value1
            ? 'bg-teal-400 text-white border-teal-400'
            : 'bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-white border-slate-100 dark:border-slate-700'
        }`}
        onClick={() => handleOptionChange(value1)}
      >
        <span className="">{caption1}</span>
        </div>
      

      
        <div
        className={`font-inter w-full text-xs border hover:border-teal-400 font-bold text-center cursor-pointer py-4 rounded-md ease-in-out duration-300 transition-all ${
          selectedOption === value2
            ? 'bg-teal-400 text-white border-teal-400'
            : 'bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-white border-slate-100 dark:border-slate-700'
        }`}
        onClick={() => handleOptionChange(value2)}
      >
        <span className="">{caption2}</span>
        </div>

{caption3 && value3 &&        <div
        className={`font-inter w-full text-xs border hover:border-teal-400 font-bold text-center cursor-pointer py-4 rounded-md ease-in-out duration-300 transition-all ${
          selectedOption === value3
            ? 'bg-teal-400 text-white border-teal-400'
            : 'bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-white border-slate-100 dark:border-slate-700'
        }`}
        onClick={() => handleOptionChange(value3)}
      >
        <span className="">{caption3}</span>
        </div>}


        {caption4 && value4 &&        <div
        className={`font-inter w-full text-xs border hover:border-teal-400 font-bold text-center cursor-pointer py-4 rounded-md ease-in-out duration-300 transition-all ${
          selectedOption === value4
            ? 'bg-teal-400 text-white border-teal-400'
            : 'bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-white border-slate-100 dark:border-slate-700'
        }`}
        onClick={() => handleOptionChange(value4)}
      >
        <span className="">{caption4}</span>
        </div>}
      
      


    </div>




          </>
     )
}

export default RadioButton_1